module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#edit",
      toString: function () {
        return this.url;
      }
    }